import React, { useState, useRef, useEffect } from 'react';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { useSiteContent } from '../context/SiteContentContext';
import { setCheckoutFlow } from '../utils/checkoutFlow';

export default function Navbar({ onAuthClick, onOrderNow }) {
  const { cartCount, currentPage, setCurrentPage } = useCart();
  const { user, logout } = useAuth();
  const { config } = useSiteContent();
  const [menuOpen, setMenuOpen] = useState(false);
  const [userMenu, setUserMenu] = useState(false);
  const [sliderIdx, setSliderIdx] = useState(0);
  const dropRef = useRef(null);

  const sliderTexts = [config?.slider_1 || 'LIMITED STOCK - ORDER NOW', config?.slider_2 || 'WINTER SALE IS LIVE NOW'].filter(Boolean);

  useEffect(() => {
    if (sliderTexts.length <= 1) return;
    const t = setInterval(() => setSliderIdx(i => (i + 1) % sliderTexts.length), 3000);
    return () => clearInterval(t);
    // eslint-disable-next-line
  }, [sliderTexts.length]);

  const nav = (page) => {
    setCurrentPage(page);
    setMenuOpen(false);
    setUserMenu(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Every ORDER NOW entry point: customer picks the pack on the checkout page.
  const goOrderNow = () => {
    setCheckoutFlow('choose');
    if (onOrderNow) onOrderNow(); else nav('checkout');
  };

  const handleLogout = async () => {
    await logout();
    setUserMenu(false);
    nav('home');
  };

  useEffect(() => {
    const h = (e) => { if (dropRef.current && !dropRef.current.contains(e.target)) setUserMenu(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const avatar = user?.displayName?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || 'U';

  return (
    <>
      <div className="top-slider">
        <button className="ts-arrow" onClick={() => setSliderIdx(i => (i - 1 + sliderTexts.length) % sliderTexts.length)}>‹</button>
        <div className="ts-track">
          <span className="ts-text" key={sliderIdx}>{sliderTexts[sliderIdx]}</span>
        </div>
        <button className="ts-arrow" onClick={() => setSliderIdx(i => (i + 1) % sliderTexts.length)}>›</button>
      </div>

      <nav>
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span /><span /><span />
        </button>

        <a className="nav-brand" onClick={() => nav('home')}>
          <img src="/images/badge_color.webp" alt="Organic Slim Fit" className="nav-logo-img" width="48" height="48" />
          <div className="nav-brand-text">
            <span className="nav-brand-name">Organic Slim Fit</span>
            <span className="nav-brand-tagline">Natural Herbal Fat Loss Tea</span>
          </div>
        </a>

        <ul className="nav-links">
          {['home', 'reviews', 'contact', 'blog', 'videos'].map(page => (
            <li key={page}>
              <a className={currentPage === page ? 'active' : ''} onClick={() => nav(page)}>
                {page.charAt(0).toUpperCase() + page.slice(1)}
              </a>
            </li>
          ))}
          <li>
            <a className={currentPage === 'track' ? 'active' : ''} onClick={() => nav('track')} style={{ color: 'var(--gold)' }}>
              🔍 Track Order
            </a>
          </li>
        </ul>

        <div className="nav-right">
          <button className="cart-btn" onClick={() => nav('cart')} title="Cart">
            🛒 {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </button>

          {user ? (
            <div className="user-menu-wrap" ref={dropRef}>
              <button className="user-btn" onClick={() => setUserMenu(v => !v)}>
                <span className="user-avatar">{avatar}</span>
                <span className="user-name">{user.displayName || user.email?.split('@')[0]}</span>
                <span className={`user-chevron ${userMenu ? 'open' : ''}`}>▼</span>
              </button>
              {userMenu && (
                <div className="user-dropdown">
                  <div className="user-dropdown-header">
                    <div className="udh-avatar">{avatar}</div>
                    <div>
                      <div className="user-dropdown-name">{user.displayName || 'Customer'}</div>
                      <div className="user-dropdown-email">{user.email}</div>
                    </div>
                  </div>
                  <div className="user-dropdown-menu">
                    <button onClick={() => nav('profile')}><span className="udi">👤</span> My Profile</button>
                    <button onClick={() => nav('profile')}><span className="udi">📦</span> Order History</button>
                    <button onClick={() => nav('track')}><span className="udi">🔍</span> Track Order</button>
                    <button onClick={() => { goOrderNow(); setUserMenu(false); }}><span className="udi">🛒</span> New Order</button>
                    <div className="user-dropdown-divider" />
                    <button onClick={handleLogout} className="logout-item"><span className="udi">🚪</span> Logout</button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <button className="login-nav-btn desktop-only" onClick={onAuthClick}>👤 Login</button>
          )}

          <button className="order-now-btn order-now-blink desktop-only" onClick={goOrderNow}>
            <span className="btn-order">Order</span>
            <span className="btn-now">Now</span>
          </button>
        </div>
      </nav>

      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <button className="mobile-close" onClick={() => setMenuOpen(false)}>✕</button>
        <div className="mobile-order-section">
          <button className="mobile-order-now-btn" onClick={() => { goOrderNow(); setMenuOpen(false); }}>
            ⚡ Order Now — Cash on Delivery
          </button>
        </div>
        <div className="mobile-divider" />
        <a onClick={() => nav('home')}>🏠 Home</a>
        <a onClick={() => nav('reviews')}>⭐ Reviews</a>
        <a onClick={() => nav('blog')}>Blog</a>
        <a onClick={() => nav('videos')}>Videos</a>
        <a onClick={() => nav('contact')}>📞 Contact</a>
        <a onClick={() => nav('track')} style={{ color: 'var(--gold)' }}>🔍 Track Order</a>
        <a onClick={() => nav('cart')}>🛒 Cart {cartCount > 0 && `(${cartCount})`}</a>
        <div className="mobile-divider" />
        {user ? (
          <>
            <a onClick={() => nav('profile')}>👤 My Profile & Orders</a>
            <a onClick={handleLogout} style={{ color: '#e74c3c' }}>🚪 Logout</a>
          </>
        ) : (
          <a onClick={() => { setMenuOpen(false); onAuthClick(); }}>👤 Login / Sign Up</a>
        )}
      </div>
    </>
  );
}
